import React, {
  useState,
  useEffect
} from 'react';

import {
  Modal,
  Button,
  Container,
  Row,
  Col
} from 'react-bootstrap';

import Swal from 'sweetalert2';
import RequestServies from '../../../services/RequestServies';
import Select from "react-select";


const AddMrvForm = ({
  show,
  handleClose,
  store,
  onSuccess
}) => {

  const initialFormValues = {
    mrvNo: 0,
    store: '',
    image: null
  };


  const [
    formValues,
    setFormValues
  ] = useState(
    initialFormValues
  );


  const [
    previewImage,
    setPreviewImage
  ] = useState(
    'img/placeholder-img.png'
  );


  const [
    isCompressing,
    setIsCompressing
  ] = useState(false);


  const [
    uploadProgress,
    setUploadProgress
  ] = useState(0);


  // ============================================================
  // INPUT CHANGE
  // ============================================================

  const handleInputChange =
    (event) => {

      const {
        name,
        value
      } = event.target;


      setFormValues(
        (prev) => ({
          ...prev,
          [name]:
            value
        })
      );
    };


  // ============================================================
  // IMAGE CHANGE + COMPRESSION
  // ============================================================

  const handleFileChange =
    async (event) => {

      const files =
        event.target.files;


      if (
        !files ||
        files.length === 0
      ) {
        return;
      }


      const file =
        files[0];


      // ==========================================
      // PREVIEW ORIGINAL IMAGE
      // ==========================================

      const previewURL =
        URL.createObjectURL(
          file
        );


      setPreviewImage(
        previewURL
      );


      setIsCompressing(
        true
      );


      try {

        const img =
          new Image();


        img.src =
          previewURL;


        img.onload = () => {

          const canvas =
            document.createElement(
              "canvas"
            );


          const MAX_WIDTH =
            800;


          // ========================================
          // DON'T ENLARGE SMALL IMAGE
          // ========================================

          const scale =
            Math.min(
              1,
              MAX_WIDTH /
                img.width
            );


          canvas.width =
            Math.round(
              img.width *
                scale
            );


          canvas.height =
            Math.round(
              img.height *
                scale
            );


          const ctx =
            canvas.getContext(
              "2d"
            );


          ctx.drawImage(
            img,
            0,
            0,
            canvas.width,
            canvas.height
          );


          // ========================================
          // CONVERT TO COMPRESSED JPEG
          // ========================================

          canvas.toBlob(
            (blob) => {

              setIsCompressing(
                false
              );


              if (!blob) {

                setFormValues(
                  (prev) => ({
                    ...prev,
                    image:
                      file
                  })
                );

                return;
              }


              const compressedFile =
                new File(
                  [blob],
                  file.name,
                  {
                    type:
                      "image/jpeg",

                    lastModified:
                      Date.now()
                  }
                );


              console.log(
                "MTN ORIGINAL IMAGE:",
                (
                  file.size /
                  1024 /
                  1024
                ).toFixed(2),
                "MB"
              );


              console.log(
                "MTN COMPRESSED IMAGE:",
                (
                  compressedFile.size /
                  1024 /
                  1024
                ).toFixed(2),
                "MB"
              );


              setFormValues(
                (prev) => ({
                  ...prev,
                  image:
                    compressedFile
                })
              );

            },

            "image/jpeg",

            0.7
          );
        };


        img.onerror = () => {

          setIsCompressing(
            false
          );


          setFormValues(
            (prev) => ({
              ...prev,
              image:
                file
            })
          );
        };


      } catch (error) {

        console.error(
          "MTN IMAGE COMPRESSION ERROR:",
          error
        );


        setIsCompressing(
          false
        );


        setFormValues(
          (prev) => ({
            ...prev,
            image:
              file
          })
        );
      }
    };


  // ============================================================
  // VALIDATION
  // ============================================================

  const validateForm =
    () => {

      if (
        !formValues.mrvNo ||
        formValues.mrvNo <= 0
      ) {

        Swal.fire({
          icon:
            'warning',

          title:
            'Missing MTN No',

          text:
            'Please enter a valid MTN Number.'
        });

        return false;
      }


      if (
        !formValues.store
      ) {

        Swal.fire({
          icon:
            'warning',

          title:
            'Missing Store',

          text:
            'Please select a store from the list.'
        });

        return false;
      }


      if (
        !formValues.image
      ) {

        Swal.fire({
          icon:
            'warning',

          title:
            'Missing Image',

          text:
            'Please upload an image.'
        });

        return false;
      }


      return true;
    };


  // ============================================================
  // SUBMIT
  // ============================================================

  const handleSubmit =
    async (event) => {

      event.preventDefault();


      if (
        isCompressing
      ) {

        Swal.fire({
          icon:
            "info",

          title:
            "Please Wait",

          text:
            "Image is still being processed."
        });

        return;
      }


      if (
        !validateForm()
      ) {
        return;
      }


      try {

        setUploadProgress(
          0
        );


        const formData =
          new FormData();


        // ==========================================
        // KEEP EXISTING FIELDS
        // ==========================================

        formData.append(
          "mrvNo",
          formValues.mrvNo
        );


        formData.append(
          "store",
          formValues.store
        );


        // IMPORTANT:
        // keep field according to backend multer
        formData.append(
          "image",
          formValues.image
        );


        await RequestServies
          .createMtn(
            formData,
            (progressEvent) => {

              if (
                !progressEvent
                  ?.total
              ) {
                return;
              }


              const percent =
                Math.round(
                  (
                    progressEvent
                      .loaded *
                    100
                  ) /
                  progressEvent
                    .total
                );


              setUploadProgress(
                percent
              );
            }
          );


        Swal.fire({
          icon:
            'success',

          title:
            'Success',

          text:
            'MTN form added successfully!'
        });


        setUploadProgress(
          0
        );


        handleClose();

        onSuccess();


      } catch (error) {

        setUploadProgress(
          0
        );


        Swal.fire({
          icon:
            'error',

          title:
            'Error',

          text:
            error
              ?.response
              ?.data
              ?.message ||
            'Failed to add requisition form!'
        });
      }
    };


  // ============================================================
  // RESET ON CLOSE
  // ============================================================

  useEffect(() => {

    if (!show) {

      setFormValues(
        initialFormValues
      );


      setPreviewImage(
        'img/placeholder-img.png'
      );


      setIsCompressing(
        false
      );


      setUploadProgress(
        0
      );
    }

  }, [
    show
  ]);


  // ============================================================
  // RENDER
  // ============================================================

  return (

    <Modal
      className="fade"
      show={show}
      onHide={handleClose}
    >

      <form
        onSubmit={
          handleSubmit
        }
      >

        <Modal.Header>

          <Modal.Title>
            MTN Form
          </Modal.Title>

        </Modal.Header>


        <Modal.Body>

          <Container>

            <Row>

              <Col md="6">

                <label>
                  Mrv No
                </label>

                <input
                  type="number"
                  name="mrvNo"
                  value={
                    formValues
                      .mrvNo
                  }
                  onChange={
                    handleInputChange
                  }
                  className="form-control form-control-sm"
                />

              </Col>


              <Col md="6">

                <label>
                  Store
                </label>

                <Select
                  options={
                    store?.map(
                      (s) => ({
                        value:
                          s._id,

                        label:
                          s.name
                      })
                    ) ||
                    []
                  }

                  value={
                    store
                      ?.map(
                        (s) => ({
                          value:
                            s._id,

                          label:
                            s.name
                        })
                      )
                      .find(
                        (opt) =>
                          opt.value ===
                          formValues
                            .store
                      ) ||
                    null
                  }

                  onChange={(
                    selected
                  ) =>
                    setFormValues(
                      (prev) => ({
                        ...prev,

                        store:
                          selected
                            ? selected.value
                            : ""
                      })
                    )
                  }

                  placeholder="Search Store..."

                  noOptionsMessage={() =>
                    "No stores found"
                  }

                  isSearchable
                />

              </Col>

            </Row>


            <Row className="mt-3">

              <Col md="6">

                <label>
                  Upload Image
                </label>


                <input
                  type="file"

                  name="image"

                  accept="image/*"

                  capture="environment"

                  className="form-control form-control-sm"

                  onClick={(e) => {
                    e.target.value =
                      null;
                  }}

                  onChange={
                    handleFileChange
                  }
                />


                {/* COMPRESSION LOADER */}

                {
                  isCompressing && (

                    <div className="text-center mt-2">

                      <div
                        className="spinner-border text-primary"
                        role="status"
                      />

                      <div className="mt-1">

                        Compressing image...

                      </div>

                    </div>

                  )
                }


                {/* PREVIEW */}

                {
                  previewImage &&
                  previewImage !==
                    'img/placeholder-img.png' &&
                  !isCompressing && (

                    <div className="file-preview text-center mt-2">

                      <img
                        id="uploadFile"
                        src={
                          previewImage
                        }
                        alt="Preview"
                        className="img-fluid"

                        style={{
                          maxHeight:
                            "200px",

                          objectFit:
                            "contain"
                        }}
                      />

                    </div>

                  )
                }


                {/* UPLOAD PROGRESS */}

                {
                  uploadProgress >
                    0 &&
                  uploadProgress <
                    100 && (

                    <div className="progress mt-2">

                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"

                        style={{
                          width:
                            `${uploadProgress}%`
                        }}
                      >

                        Uploading...{" "}
                        {
                          uploadProgress
                        }%

                      </div>

                    </div>

                  )
                }

              </Col>

            </Row>

          </Container>

        </Modal.Body>


        <Modal.Footer>

          <Button
            variant="danger light"
            onClick={
              handleClose
            }
            disabled={
              isCompressing ||
              uploadProgress > 0
            }
          >

            Close

          </Button>


          <Button
            variant="primary"
            type="submit"

            disabled={
              isCompressing ||
              uploadProgress > 0
            }
          >

            {
              isCompressing
                ? "Processing..."
                : uploadProgress >
                    0
                  ? "Uploading..."
                  : "Save changes"
            }

          </Button>

        </Modal.Footer>

      </form>

    </Modal>
  );
};


export default AddMrvForm;